import classNames from 'classnames';
import React from 'react';

interface Props {
  active?: boolean;
  className?: string;
  striped?: boolean;
  value: number;
  type?: string;
}

export default function ProgressBar({
  active = false,
  className,
  striped = false,
  value,
  type,
}: Props): JSX.Element {
  return (
    <div
      className={classNames(className, 'progress', {
        'progress-striped': striped,
        active: active && striped, // `active` only has a visual impact if `striped`
      })}
    >
      <div
        role="progressbar"
        className={classNames({
          'progress-bar': true,
          'progress-bar-success': type === 'success',
          'progress-bar-warning': type === 'warning',
          'progress-bar-danger': type === 'danger',
          'progress-bar-onboarding': type === 'onboarding',
        })}
        style={{
          width: `${value}%`,
        }}
      />
    </div>
  );
}
